import { Box, Stack } from "@mui/material"
import { PropsWithChildren } from "react"

export function SimpleBackgroundLayout({ children }: PropsWithChildren) {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw"
      }}>
      <img
        alt={"headigital"}
        loading={"lazy"}
        src={"/images/feg-background.png"}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1
        }}
      />
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          gap: 4
        }}>
        {children}
      </Stack>
    </Box>
  );
}
